define('Components/SponsorshipWidget/js/views/SponsorshipWidgetInstanceView',[
        'jquery',
        'WidgetInstanceView',
        'app',
        'template!Components/SponsorshipWidget/templates/eligible-customer',
        'template!Components/SponsorshipWidget/templates/non-eligible-customer',
        'InternalLinkView',
        'views/blocks/AuthentificationLoginView',
        'testEmail',
        'router',
        'taggle',
        'UrlFactory',
        'formatSmsLink'
    ],
    function ($,
              WidgetInstanceView,
              app,
              EligibleCustomerTemplate,
              NonEligibleCustomerTemplate,
              InternalLinkView,
              AuthentificationLoginView,
              testEmail,
              router,
              Taggle,
              UrlFactory,
              formatSmsLink
    ) {
        var tagsInput;
        var copyToClipboardTimeout_1 = null, copyToClipboardTimeout_2 = null;

        var SPONSORSHIP_TRANSLATION_CONTEXT = 'Sponsorship';

        return WidgetInstanceView.extend({
            name: 'SponsorshipWidgetInstanceView',
            events: {
                "click .send-sponsorship-code": "sendCodeByEmail",
                "click .SponsorshipWidget__Cta__button": 'goToListing',
                'click .icon-clipboard-copy': 'copyCodeToClipboard'
            },
            setup: function () {
                var view = this, model = view.model;
                if(!model.isLogged() && model.getTemplate()==='non-eligible-customer'){
                    var modalView = new AuthentificationLoginView({introduction:model.p('non_logged_introduction')});
                    view.listenToOnce(modalView,'close',function(){
                        if(!model.isLogged()){
                            setTimeout(function(){
                                router.go(model.p('non_logged_redirect'));
                            },50)
                        }
                    });
                    setTimeout(function(){
                        // setTimeout tricky trick !!!
                        app.displayModal(modalView);
                    },50);
                }


                $('.home-loader').remove();
                view.listenTo(app.getCustomer(), "login logout", view.reRender);
                InternalLinkView.initializeLinksOfView(view);
            },
            sendCodeByEmail: function (e) {
                e.preventDefault();
                var view = this;
                var emailList = tagsInput.getTagValues().join(' ');
                var hasInvalidEmails = false;
                tagsInput.getTagValues().forEach(function (email) {
                    if (testEmail(email) === false) {
                        hasInvalidEmails = true;
                    }
                });

                if (hasInvalidEmails) {
                    app.banNotice(t("Un ou plusieurs email(s) saisis n'est pas valide", SPONSORSHIP_TRANSLATION_CONTEXT));
                } else {
                    var sendSponsorshipCode = view.$el.find('.send-sponsorship-code');
                    sendSponsorshipCode
                        .addClass('loading')
                        .attr('disabled', 'disabled');

                    app.getCustomer().sponsorshipSendByEmail(emailList)
                        .done(function () {
                            app.banNotice(t('Votre invitation à bien été envoyée', SPONSORSHIP_TRANSLATION_CONTEXT));
                        })
                        .fail(function (data) {
                           var response = data.responseJSON;

                            app.banNotice(t("Votre invitation n'a pas pu être envoyée" ,  SPONSORSHIP_TRANSLATION_CONTEXT)  + " : " + response.error);
                        })
                        .always(function () {
                            sendSponsorshipCode
                                .removeClass('loading')
                                .removeAttr("disabled");
                        });
                }
            },
            reRender: function () {
                var tpl = this.getTemplate()(this.getTemplateOptions());
                this.$el.html(tpl);
                this.$el = $(this.el);
                this.afterRender()
            },
            afterRender: function () {
                var view = this;
                var checkIfInputHasTags = function () {
                    $('.taggle_list .taggle').length > 0
                        ? $('.send-sponsorship-code').removeAttr('disabled')
                        : $('.send-sponsorship-code').attr('disabled', true);
                };
                setTimeout(function () {
                    if ($('.taggle_list').length === 0 && $('.eligible-template').length !== 0) {
                        tagsInput = new Taggle('sponsorship-emails-list', {
                            placeholder: t("Saississez les adresses e-mail", "Sponsorship"),
                            submitKeys: [188, 9, 13, 32],
                            onBeforeTagAdd: function (event, tag) {
                                return testEmail(tag);
                            },
                            onTagAdd: function () {
                                checkIfInputHasTags()
                            },
                            onTagRemove: function () {
                                checkIfInputHasTags()
                            },
                            saveOnBlur: true
                        });

                        view.$el.find('.SponsorshipWidget__Share__form').submit(function (e) {
                            e.preventDefault();
                        });
                    }
                }, 500);
            },
            getTemplate: function () {
                var template;
                switch (this.model.getTemplate()) {
                    case 'eligible-customer':
                        template = EligibleCustomerTemplate;
                        break;
                    case 'non-eligible-customer':
                        template = NonEligibleCustomerTemplate;
                        break;
                }
                return template;
            },
            goToListing: function () {
                app.go('listing');
            },
            copyCodeToClipboard: function () {
                var $tempInput = $("<input>");
                var view = this;

                clearTimeout(copyToClipboardTimeout_1);
                clearTimeout(copyToClipboardTimeout_2);

                $("body").append($tempInput);
                $tempInput.val(view.model.getSponsorshipCode()).select();
                document.execCommand("copy");
                $tempInput.remove();

                if (app.isMobile()) {
                    $('.SponsorshipWidget__Share__title .icon-clipboard-copy').addClass('copied');
                }
                $('.SponsorshipWidget__Share__title .copy-tooltip').html(function () {
                    return t('Copié', SPONSORSHIP_TRANSLATION_CONTEXT);
                });

                copyToClipboardTimeout_1 = setTimeout(function () {
                    copyToClipboardTimeout_2 = setTimeout(function () {
                        $('.SponsorshipWidget__Share__title .icon-clipboard-copy').removeClass('copied');
                    }, 200);
                    if (app.isDesktop()) {
                        $('.SponsorshipWidget__Share__title .copy-tooltip').html(function () {
                            return t('Copier le code', SPONSORSHIP_TRANSLATION_CONTEXT);
                        });
                    }
                }, 5000);
            }
        })
    });

